import {itemCreditLines} from "@Common/logic/cart/item-credit-lines";
import {sum}             from "@Common/utils/collections";
import {chain}           from "@Common/utils/fs";
import {values}          from "@Common/utils/objects";

export const SummarySections = ({item, cart,})=> chain(
    values(item.itemTotals),
    (total) => {

        const lines = [
            {
                label: "Subtotal",
                value: total.find((t) => t.type === "subTotal").amount,
            },
            chain(
                total.find((t) => t.type === "shippingCharge"),
                (t) => t && ({
                    label: "Shipping",
                    value: t.amount,
                }),
            ),
            chain(
                total.find((t) => t.type === "handlingFee"),
                (t) => t && ({
                    label: "Handling Fee",
                    value: t.amount,
                })
            ),
            chain(
                total.find((t) => t.type === "salesTax"),
                (t) => t && ({
                    label: "Sales Tax",
                    value: t.amount,
                }),
            ),
            chain(
                total.find((t) => t.type === "rdf"),
                (t) => t && ({
                    label: t.name,
                    value: t.amount,
                    description: t.description,
                }),
            ),
            chain(
                total.find((t) => t.type === "vatTax"),
                (t) => t && ({
                    label: "VAT/GST",
                    value: t.amount,
                    description: t.description,
                }),
            ),
            chain(
                total.find((t) => t.type === "importTax"),
                (t) => t && ({
                    label: "Import Duties",
                    value: t.amount,
                }),
            ),
            ...itemCreditLines({item, cart,}),
        ].filter(v => v);

        return [
            {
                lines,
            },
            {
                lines: [
                    {
                        label: "Order Total",
                        value: sum(lines, (t) => t.value),
                        big: true,
                    },
                ],
            },
        ];
    }
);
